import { Component, OnInit, OnChanges, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ExpenseService } from '../../services/expense.service';
import { CurrencyService } from '../../services/currency.service';
import { CustomizationService } from 'src/app/services/customization.service';
import { map } from "rxjs/operators";

@Component({
    selector: 'app-expense-filter',
    templateUrl: './expense-filter.component.html',
    styleUrls: ['./expense-filter.component.scss'],
    standalone: false
})
export class ExpenseFilterComponent implements OnInit, OnChanges {
  public users;
  public selectedUsers;
  public itemStates;
  public selectedItemStates;
  public itemCategories;
  public selectedItemCategories;
  public journals;
  public selectedJournals;
  public currencies;
  public defaultCurrency;
  public selectedCurrencies;
  public selectedStateID;
  public userDataLoaded = false;
  public journalsLoaded = false;
  public from;
  public to;
  public APITokens;

  private subscriptions = [];

  @Input() inputState: any[];
  @Input() displayState: boolean;
  @Input() journalsFilter: boolean = false;

  @Output() filterChanged = new EventEmitter<any>();
  @Output() loadEvent = new EventEmitter<any>();

  constructor(
    private userService: UserService,
    private expenseService: ExpenseService,
    private currencyService: CurrencyService,
    private customizationService: CustomizationService,
  ) {
    const currentDate = new Date();
    this.from = new Date(currentDate.getFullYear(), new Date().getMonth(), 2)
      .toISOString()
      .split('T')[0];
    this.to = new Date(currentDate.getFullYear(), new Date().getMonth() + 1, 1)
      .toISOString()
      .split('T')[0];
    this.customizationService.loadAPITokens('all');
    this.expenseService.loadItemCategories('all');
    this.expenseService.loadItemStates('all');
    this.loadUsersByDateRange();
    this.currencyService.load('all');
    this.loadJournals();
    this.users = this.userService.$allUsers;
    this.itemStates = this.expenseService.$itemStates;
    this.itemCategories = this.expenseService.$itemCategories;
    this.currencies = this.currencyService.$currencies;
    this.defaultCurrency = this.currencyService.$default;
    this.APITokens = this.customizationService.$apiTokens;
    this.journals = this.expenseService.$journalIds;

    const userSub = this.users.subscribe((res) => {
      this.selectedUsers = res;
    });
    const stateSub = this.itemStates.subscribe((res) => {
      this.setSelectedItemState();
    });
    const itemCategorySub = this.itemCategories.subscribe((res) => {
      this.selectedItemCategories = res;
    });
    const journalSub = this.journals.subscribe((res) => {
      this.selectedJournals = res;
    });
    const currSub = this.currencies.subscribe((res) => {
      this.selectedCurrencies = res;
    });
    this.subscriptions.push(userSub);
    this.subscriptions.push(stateSub);
    this.subscriptions.push(itemCategorySub);
    this.subscriptions.push(journalSub);
    this.subscriptions.push(currSub);
  }

  ngOnInit() {
    this.updateComponent();
  }

  ngOnChanges() {
    this.updateComponent();
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  updateComponent() {
    if (this.displayState === undefined || this.displayState === null) {
      this.displayState = true;
    }
    if (this.selectedUsers === undefined) {
      this.selectedUsers = this.users.value;
    }
    if (this.userDataLoaded && this.journalsLoaded) {
    }
    this.setSelectedItemState();
  }

  private setSelectedItemState() {
    if (this.inputState !== undefined && this.itemStates.value !== undefined) {
      try {
        this.selectedStateID = this.itemStates.value.find(
          (obj) => obj.name === this.inputState
        )['id'];
        this.selectItemStates(
          this.itemStates.value.find((obj) => obj.name === this.inputState)
        );
      } catch (e: any) {
        //Do nothing if "id" is not available.
      }
    } else {
      this.selectItemStates(this.itemStates.value);
    }
  }

  private loadJournals() {
    const filter: any = {
      date: [{ id: this.from }, { id: this.to }],
    };
    this.expenseService
      .loadJournalIdsByDateRange('all', filter)
      .subscribe(() => {
        this.journalsLoaded = true;
        this.emitFilterChange();
      });
  }

  emitFilterChange() {
    if (this.userDataLoaded && this.journalsLoaded) {
      this.filterChanged.emit(this.getFilterData());
    }
  }

  emitLoadEvent() {
    this.loadEvent.emit(this.getFilterData());
  }

  months(forward: boolean) {
    let f = new Date(this.from);
    let t = new Date(this.to);
    let fromMonth = forward ? f.getMonth() + 1 : f.getMonth() - 1;
    let toMonth = forward ? t.getMonth() + 2 : t.getMonth();
    let fromYear = f.getFullYear();
    let toYear = t.getFullYear();

    if (fromMonth === -1) {
      fromMonth = 11;
      fromYear--;
    } else if (fromMonth === 12) {
      fromMonth = 0;
      fromYear++;
    }

    if (toMonth === -1) {
      toMonth = 11;
      toYear--;
    } else if (toMonth === 12) {
      toMonth = 0;
      toYear++;
    }

    f = new Date(fromYear, fromMonth, 2);
    t = new Date(toYear, toMonth, 1);
    this.from = f.toISOString().split('T')[0];
    this.to = t.toISOString().split('T')[0];
    this.onDateChange();
  }

  loadUsersByDateRange() {
    this.userService
      .loadUsersByDateRange('all', false, 'expenses', this.from, this.to)
      .subscribe((res) => {
        this.selectedUsers = res;
        this.userDataLoaded = true;
        this.emitFilterChange();
      });
  }

  onDateChange() {
    this.loadUsersByDateRange();
    this.loadJournals();
  }

  selectItemStates($event) {
    if (Array.isArray($event)) {
      this.selectedItemStates = $event;
    } else {
      let list = [];
      list.push($event);
      this.selectedItemStates = list;
    }
    this.emitFilterChange();
  }

  getFilterData() {
    return {
      users: this.selectedUsers,
      itemStates: this.selectedItemStates,
      itemCategories: this.selectedItemCategories,
      ...(this.journalsFilter && {
        journals: this.selectedJournals
      }),
      currencies: this.selectedCurrencies,
      date: [{ id: this.from }, { id: this.to }],
    };
  }

  isFilterEmpty(): boolean {
    return [
      this.selectedUsers,
      this.selectedItemStates,
      this.selectedItemCategories,
      this.selectedCurrencies,
    ].some((list) => !list || list.length === 0);
  }

  onSelectedJournalsChange($event) {
    this.selectedJournals = $event;
  }

  hasBexioToken() {
    return this.APITokens.getValue().some(
      (element) => element.key === 'bexio' && element.active === 1
    );
  }
}
